import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import { BrdsqlService } from '../../services/brdsql.service';
import * as echarts from 'echarts';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-dashboardkpi',
  templateUrl: './dashboardkpi.component.html',
  styleUrls: ['./dashboardkpi.component.css']
})
export class DashboardkpiComponent implements OnInit, OnDestroy {
  chartOptions_ton: EChartsOption = {};
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
    // console.log(this.userdata)
  }
  year_L = [    //รายการปี
    { "yearTh": "6566", "yearlf": "65", "yearCr": "2223", "yearDesc": "ปี 2565/2566", "state": 0 },
    { "yearTh": "6667", "yearlf": "66", "yearCr": "2324", "yearDesc": "ปี 2566/2567", "state": 0 },
    { "yearTh": "6768", "yearlf": "67", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "state": 0 },
    { "yearTh": "6869", "yearlf": "68", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "state": 0 },
    { "yearTh": "6970", "yearlf": "69", "yearCr": "2627", "yearDesc": "ปี 2569/2570", "state": 1 }

  ]
  year_S: any = [];//{ yearTh: "", yearlf: "", yearCr: "", yearDesc: "", state: 0 };//ปีที่เลือก

  ngOnInit(): void {
    const chartCon1 = document.getElementById('ChartTypeMC') as HTMLDivElement;
    //const chartInst1 = echarts.init(chartCon1);
    //this.chartInstances.push(chartInst1);
    this.s_check = 1;
    let year = this.year_L.filter((el) => (el.state) == 1);//this.year_L.find(item => item.state === 1);
    //console.log("year", year);
    this.year_S = year[0]//{ yearTh: "6768", yearlf: "67", yearCr: "2425", yearDesc: "ปี 2567/2568" }
    this.s_list = 1;
    this.Loadkpiall();
    //this.Load_AssessChartM()
  }
  loader: boolean;
  allkpidata = [];
  f_allkpidata = [];

  supportterlist: any;
  areacode: any;
  arealist: any;
  listDataNow: any;
  listDataNow2: any;


  selectsup = this.brdsql.sumZonne;
  selectS = [];

  slz = false;
  filter_data() {
    let aj = this.selectS;
    let data = this.f_allkpidata
    if (data.length > 0) {
      if (aj[1] == "") {
        this.allkpidata = data;
        this.slz = false;
      }
      else if (aj[1] != "sum") {
        this.allkpidata = data.filter((el) => (el.supzone) == aj[1]);
        this.slz = true;
      }
      else if (aj[1] == "sum") {
        this.allkpidata = data.filter((el) => (el.Partcode) == aj[0]);
        this.slz = false;
      }
      setTimeout(() => {
        this.Swaptab(this.s_check);
        //this.click_list()
      }, 200);
    }
  }

  select_year() {
    let year = this.year_S;
    this.Loadkpiall();
    console.log('year_S :', year);
    //console.log('year_S[01] :',year[0],year[1])    
  }

  s_list: number;
  click_list() {
    let sl = this.s_list;
    if (sl == 1) { this.TopicChart01(); }//ปริมาณอ้อย
    else if (sl == 2) { this.TopicChart02(); }//ผลผลิต
    else if (sl == 3) { this.TopicChart03(); }//พื้นที่ปลูก
    else if (sl == 4) { this.TopicChart04(); }//ระเบิดดาน
    else if (sl == 5) { /*this.load_seed();*/ }//พันธุ์อ้อย
    else if (sl == 6) { this.TopicChart06(); }//ระยะร่อง
    else if (sl == 7) { this.TopicChart07(); }//เคมี 1
    else if (sl == 8) { this.TopicChart08(); }//เคมี 2
    else if (sl == 9) { this.TopicChart09(); }//เคมี 3
    else if (sl == 10) { this.TopicChart10(); }//อินทรีย์
    else if (sl == 11) { this.TopicChart11(); }//โดโลไมท์
    else if (sl == 12) { this.TopicChart12(); }//% งอก
    else if (sl == 13) { this.TopicChart13(); }//วัชพืช
    else if (sl == 14) { this.TopicChart14(); }//%กิจกรรม
    else if (sl == 15) { this.TopicChart15(); }//%ข้อมูลอ้อย
    else if (sl == 16) { this.TopicChart16(); }//อัพเดตแปลง
    else if (sl == 17) { this.TopicChart17(); }//สินเชื่อ
    else if (sl == 23) { this.TopicChart23(); }//ประเมินตัน
    else if (sl == 24) { this.TopicChart24(); }//ปริมาณตัน
    else if (sl == 25) { this.TopicChart25(); }//เกรดชาวไร่

    console.log('s_list /', this.s_list)
  }

  hText: string = 'โซน';
  s_check: number;
  showMenu: boolean = true;

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  private formatNumber(num: number, fractionDigits: number = 2, default_v: string = '0.00'): string {
    if (num === null || num === undefined || isNaN(num)) {
      return default_v;
    }
    return new Intl.NumberFormat('th-TH', { maximumFractionDigits: fractionDigits }).format(num);
  }

  Swaptab(check: number) {
    this.s_check = check
    let data = this.allkpidata;
    if (check == 1) {//โซน
      this.listDataNow = data.filter(el => el.supcode == 'sum' && el.supzone != 'sum')
      this.listDataNow2 = data.filter(el => el.supcode == 'sum' && (el.supzone != 'sum' || el.Partcode == 'BRD'))
      this.hText = 'โซน';
    }
    else if (check == 2) {//นสส
      this.listDataNow = data.filter(el => el.supzone != 'sum' && el.supcode != 'sum' && el.Partcode != 'BRD')
      this.listDataNow2 = data.filter(el => el.supzone != 'sum' && el.supcode != 'sum')
      this.hText = 'นักส่งเสริม';
    }
    else if (check == 3) {//ส่วน
      this.listDataNow = data.filter(el => el.supcode == 'sum' && el.supzone == 'sum' && el.Partcode != 'BRD')
      this.listDataNow2 = data.filter(el => el.supcode == 'sum' && el.supzone == 'sum')
      this.hText = 'ส่วน';
    }
    setTimeout(() => {
      console.log('hText /', this.hText)
      this.click_list();
    }, 100);
  }


  partcode: any;
  partlist: any;
  mysup: any;
  Loadkpiall() {
    this.load_seed();
    //console.log('Loadkpiall()')
    //this.spinner.show();
    this.loader = true;
    let year = this.year_S;
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[kpi_' + year.yearlf + '01]&w=1=1';
    axios.get(url).then(res => {
      let data = res.data
      this.loader = false;
      if (data.length >= 1) {
        data.sort((a, b) => a.supzone.localeCompare(b.supzone));
        //this.spinner.hide();
        this.allkpidata = this.f_allkpidata = data;
        this.supportterlist = data.filter(el => el.supcode != 'sum')
        this.listDataNow = data.filter(el => el.supcode == 'sum' && el.supzone != 'sum')
        this.listDataNow2 = data.filter(el => el.supcode == 'sum' && (el.supzone != 'sum' || el.Partcode == 'BRD'))
        this.partlist = data.filter(el => el.supcode == 'sum' && el.supzone == 'sum' && el.Partcode == 'BRD')
        this.click_list();
        //this.spinner.hide();
      }
      else {
        this.allkpidata = [];
        this.supportterlist = [];
        this.listDataNow = [];
        this.listDataNow2 = [];
        this.partlist = [];
        this.click_list();
      }
    }).catch(err => {
      throw (err)
    });
  }

  typeChart: any;
  dataChart: any;


  ChartTypeM: any = [];
  async Load_AssessChartM() {
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.Assess - b.Assess});
    let supzone = data.map(function (elem) { return elem.supname });
    let targrt_Assess = data.map(function (elem) { return ((elem.targrt_Assess) / 1000).toFixed(1) }); // เป้า
    let Assess = data.map(function (elem) { return ((elem.Assess) / 1000).toFixed(1) }); // ประเมิน

    this.ChartTypeM = new Chart('AssessChartM', { // สร้าง object และใช้ชื่อ id lineChart ในการอ้างอิงเพื่อนำมาเเสดงผล
      type: 'Bar', // ใช้ชนิดแผนภูมิแบบเส้นสามารถเปลี่ยนชิดได้    
      data: { // ข้อมูลภายในแผนภูมิแบบเส้น
        labels: supzone, // ชื่อของข้อมูลในแนวแกน x

        datasets: [
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'เป้าหมาย',
            data: targrt_Assess,
            datalabels: {
              color: '#ffffff',
              align: 'center',
              offset: 10
            },
            fill: true,
            borderColor: "red", // สีของเส้น
            backgroundColor: "#16537e",// 
            borderWidth: 1
          }
          , { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'ผลงาน',
            data: Assess,
            datalabels: {
              color: '#ffffff',
              align: 'center',
              offset: 10
            },
            fill: true,
            borderColor: "red", // สีของเส้น
            backgroundColor: "#744700",
            borderWidth: 1
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value.toLocaleString()
            }
          },
          legend: {
            position: 'left',
            Align: 'center',
            fontSize: 16
          },

        },
        title: { // ข้อความที่อยู่ด้านบนของแผนภูมิ
          text: "พื้นที่ปลูก(ไร่) แยกตามประเภทอ้อย",
          display: true,
          fontSize: 20

        },
        scales: { // แสดง scales ของแผนภูมิเริมที่ 0
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    })
  }

  dataChartPA: any;
  optionsChartPA: any;
  TopicChart15() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_hardSoilBlast - b.pc_hardSoilBlast});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let pc_targrt_Assess = data.map(function (elem) { return elem.pc_targrt_Assess }); // 
    let pc_areas = data.map(function (elem) { return elem.pc_areas }); // 
    let pc_targrt_yield = data.map(function (elem) { return elem.pc_targrt_yield }); // 

    this.dataChartPA = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: '%ประเมินอ้อย',
          data: pc_targrt_Assess,
          fill: false,
          borderColor: '#ffd300',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '%พื้นที่ปลูก',
          data: pc_areas,
          fill: false,
          borderColor: '#2c45ff',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '%ผลผลิต',
          data: pc_targrt_yield,
          fill: false,
          borderColor: '#c8002a',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChartPA = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟแสดงผลงาน ข้อมูลแปลง ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            //beginAtZero: true,
            //max: 110
          },
        },],
      }
    };
  }

  dataChart23: any;
  optionsChart23: any;
  TopicChart23() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    let supzone = data.map(function (elem) { return elem.supname }); //
    let ton_sv = data.map(function (elem) { return elem.ton_sv }); // 
    let ton_ad = data.map(function (elem) { return elem.ton_ad }); // 
    let ton_pc = data.map(function (elem) { return elem.ton_pc }); //
    let ton_fm = data.map(function (elem) { return elem.ton_fm }); //

    this.dataChart23 = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: 'นสส ประเมินตัน/ไร่',
          data: ton_sv,
          fill: false,
          borderColor: '#f39c12',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'ออดิต ประเมินตัน/ไร่',
          data: ton_ad,
          fill: false,
          borderColor: '#1abc9c',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'หน.ส่วน ประเมินตัน/ไร่',
          data: ton_pc,
          fill: false,
          borderColor: '#3498db',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'ชาวไร่ ประเมินตัน/ไร่',
          data: ton_fm,
          fill: false,
          borderColor: '#98DB34',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart23 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟแสดง เทียบประเมิน ตัน/ไร่ ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            //max: 110
          },
        },],
      }
    };
  }

  dataChart24: any;
  optionsChart24: any;
  TopicChart24() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    let supzone = data.map(function (elem) { return elem.supname }); //
    let asses_sv = data.map(function (elem) { return elem.asses_sv }); // 
    let asses_ad = data.map(function (elem) { return elem.asses_ad }); // 
    let asses_pc = data.map(function (elem) { return elem.asses_pc }); // 
    let asses_fm = data.map(function (elem) { return elem.asses_fm }); // 

    //
    this.dataChart24 = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: 'นสส ประเมินตัน/ไร่',
          data: asses_sv,
          fill: false,
          borderColor: '#ffb3ba',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'ออดิต ประเมินตัน/ไร่',
          data: asses_ad,
          fill: false,
          borderColor: '#ffffba',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'หน.ส่วน ประเมินตัน/ไร่',
          data: asses_pc,
          fill: false,
          borderColor: '#baffc9',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: 'ชาวไร่ ประเมินตัน/ไร่',
          data: asses_fm,
          fill: false,
          borderColor: '#bae1ff',
          tension: .1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart24 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟแสดง ปริมาณตัน ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            //beginAtZero: true,
            //max: 110
          },
        },],
      }
    };
  }


  TopicChart01() {
    console.log('TopicChart01()')
    //this.typeChart = 'bar';

    var last_data, data, dataL, chart, names, values, name_chart, name_c2, sum_all;
    data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_targrt_Assess - b.pc_targrt_Assess});
    let supzone = data.map(function (elem) { return elem.supname });
    let targrt_Assess = data.map(function (elem) { return (elem.targrt_Assess).toFixed(0) }); // เป้า
    let Assess = data.map(function (elem) { return (elem.Assess).toFixed(0) }); // ประเมิน
    //let Assess_b = data.map(function (elem) { return (elem.Assess_b).toFixed(1) }); // สะสมในระบบ
    let Assess_left = data.map(function (elem) { return (elem.Assess_left).toFixed(1) }); // สะสมในระบบ
    let pc_targrt_Assess = data.map(function (elem) { return (elem.pc_targrt_Assess).toFixed(1) }); // ประเมิน
    let cane_in = data.map(function (elem) { return (elem.cane_in).toFixed(1) }); // อ้อยเข้า
    let pc_targrt_Assess_b = data.map(function (elem) { return elem.pc_targrt_Assess_b }); // สะสมในระบบ
    let pc_targrt_Assess_left = data.map(function (elem) { return elem.pc_targrt_Assess_left }); // ประเมิน

    //chart = echarts.init(document.getElementById('ChartTypeMC') as HTMLDivElement);

    const colors = ['#00ADF9', '#1abc9c', '#93C47D', '#7bc043', '#0392cf '];
    //const option = {
    this.chartOptions_ton = {
      title: {
        text: 'ภาพรวมปริมาณอ้อยราย' + this.hText,
        left: 'center'
      },
      color: colors,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
      },
      grid: {
        left: '2%',
        right: '2%',
        bottom: '2%',
        containLabel: true
      },
      toolbox: {
        orient: 'horizontal',
        feature: {
          dataView: { show: true, readOnly: false },
          saveAsImage: { show: true }
        }
      },
      legend: {
        data: ['เป้าหมาย', 'ประเมิน', 'หักสูญเสีย', 'อ้อยเข้า', '%ประเมิน'],
        top: '5%',
      },
      emphasis: {
        focus: 'series'
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: false
          },
          axisLabel: {
            interval: 'auto',
            fontSize: 14,
            rotate: 30
          },
          // prettier-ignore
          data: supzone
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '%',
          position: 'right',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#000000'
            }
          },
          axisLabel: {
            formatter: '{value} %'
          }
        },
        {
          type: 'value',
          name: 'ปริมาณตัน',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#000000'
            }
          },
          axisLabel: {
            formatter: '{value} ตัน'
          }
        }
      ],
      series: [
        {
          name: 'เป้าหมาย',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value.toLocaleString("en-EN") + ' ตัน';
            }
          },
          yAxisIndex: 1,
          label: {
            show: true,
            position: 'top',
          },
          data: targrt_Assess
        },
        {
          name: 'ประเมิน',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value.toLocaleString("en-EN") + ' ตัน';
            }
          },
          yAxisIndex: 1,
          label: {
            show: true,
            position: 'top'
          },
          data: Assess
        },
        {
          name: 'หักสูญเสีย',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value.toLocaleString("en-EN") + ' ตัน';
            }
          },
          yAxisIndex: 1,
          label: {
            show: true,
            position: 'top'
          },
          data: Assess_left
        },
        {
          name: 'อ้อยเข้า',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value.toLocaleString("en-EN") + ' ตัน';
            }
          },
          yAxisIndex: 1,
          label: {
            show: true,
            position: 'top'
          },
          data: cane_in
        },
        {
          name: '%ประเมิน',
          type: 'line',
          tooltip: {
            valueFormatter: function (value) {
              return value.toLocaleString("en-EN") + ' %';
            }
          },
          yAxisIndex: 0,
          label: {
            show: true,
            position: 'top'
          },
          data: pc_targrt_Assess
        }
      ]
    };

    /*this.chartInstances[0].setOption(option);
    window.addEventListener('resize', () => {
      this.chartInstances[0].resize();
    });*/
  }

  dataChart2: any;
  optionsChart2: any;
  TopicChart02() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_targrt_yield - b.pc_targrt_yield});
    let supzone = data.map(function (elem) { return elem.supname });
    let yield_er = data.map(function (elem) { return (elem.yield_er) }); // ปลายฝน
    let yield_st = data.map(function (elem) { return (elem.yield_st) }); // ตอ
    let yield_sr = data.map(function (elem) { return (elem.yield_sr) }); // ต้นฝน
    let yield_all = data.map(function (elem) { return elem.yield_all }); // all
    let pc_targrt_yield = data.map(function (elem) { return elem.pc_targrt_yield }); // pc
    this.dataChart2 = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: "อ้อยปลายฝน",
          data: yield_er,
          yAxisID: "id1",
          borderColor: "#f39c12",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          fill: false,
        },
        {
          type: 'line',
          label: "อ้อยต้นฝน",
          data: yield_sr,
          yAxisID: "id1",
          borderColor: "#1abc9c",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          fill: false,
        },
        {
          type: 'line',
          label: "อ้อยตอ",
          data: yield_st,
          yAxisID: "id1",
          borderColor: "#3498db",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          fill: false,
        },
        {
          type: 'line',
          label: "อ้อยรวม",
          data: yield_all,
          yAxisID: "id1",
          borderColor: "#98DB34",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          fill: false,
        },
        {
          type: 'line',
          label: '% ผลผลิต',
          data: pc_targrt_yield,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#E60B00',
          tension: 0.05,
          yAxisID: "id2",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
      ],
    };

    this.optionsChart2 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString()
          }
        }
      },

      //maintainAspectRatio: true,
      title: {
        display: true,
        text: 'กราฟผลผลิตราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{

          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            //beginAtZero: true,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            min: Math.min(0),
            max: Math.max(25),
          },
          id: "id1", // incorrect property name.
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }
  dataChart2_1: any;
  optionsChart2_1: any;
  dataChart2_2: any;
  optionsChart2_2: any;
  TopicTwo1Chart() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    let supname = data.map(function (elem) { return elem.supname });
    let nowAssessPlan08 = data.map(function (elem) { return elem.nowAssessPlan08 }); //
    let OldAssessPlan08 = data.map(function (elem) { return elem.OldAssessPlan08 }); //
    let sumTargPlan10 = data.map(function (elem) { return elem.sumTargPlan10 }); //
    let pcSumTargPlan10 = data.map(function (elem) { return elem.pcSumTargPlan10 }); //
    this.dataChart2_1 = {
      labels: supname,
      datasets: [

        {
          label: "ปริมาณอ้อยปัจจบัน",
          data: nowAssessPlan08,
          yAxisID: "id1",
          stack: 'Stack 0',
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c12','#000000']
          backgroundColor: "#ffa500",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "ปริมาณอ้อยตั้งต้น",
          data: OldAssessPlan08,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#50b397",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ปริมาณตันที่จะเพิ่มขึ้น",
          data: sumTargPlan10,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#698cdf",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          type: 'line',
          label: '% ผลผลิตที่จะเพิ่ม',
          data: pcSumTargPlan10,
          fill: false,
          borderColor: '#E60B00',
          tension: 0.05,
          yAxisID: "id2",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
      ],
    };

    this.optionsChart2_1 = {
      responsive: true,
      interaction: {
        intersect: false,
      },
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟเพิ่มผลผลิตราย' + this.hText,
        fontSize: 18
      },
      scales: {
        stacked: true,
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{

          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /* min: Math.min(0),
             max: Math.max(25),*/
          },
          id: "id1" // incorrect property name.
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /*min: Math.min(0),
            max: Math.max(110),*/
          },

          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,

          },
          //display: false,
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: {
            display: false
          },
          //yAxisID: "id2"
          id: "id2" // incorrect property name.
        }

        ],

      }
    };
    let sumCntPlan = data.map(function (elem) { return elem.sumCntPlan }); //
    let sumcntSecPlan = data.map(function (elem) { return elem.sumcntSecPlan }); //
    let pcsumcntSecPlan = data.map(function (elem) { return elem.pcsumcntSecPlan }); //

    let cntPlan01 = data.map(function (elem) { return elem.cntPlan01 }); //
    let cntPlan02 = data.map(function (elem) { return elem.cntPlan02 }); //
    let cntPlan03 = data.map(function (elem) { return elem.cntPlan03 }); //
    let cntPlan04 = data.map(function (elem) { return elem.cntPlan04 }); //
    let cntPlan05 = data.map(function (elem) { return elem.cntPlan05 }); //
    let cntPlan06 = data.map(function (elem) { return elem.cntPlan06 }); //

    let cntSecPlan01 = data.map(function (elem) { return elem.cntSecPlan01 }); //
    let cntSecPlan02 = data.map(function (elem) { return elem.cntSecPlan02 }); //
    let cntSecPlan03 = data.map(function (elem) { return elem.cntSecPlan03 }); //
    let cntSecPlan04 = data.map(function (elem) { return elem.cntSecPlan04 }); //
    let cntSecPlan05 = data.map(function (elem) { return elem.cntSecPlan05 }); //
    let cntSecPlan06 = data.map(function (elem) { return elem.cntSecPlan06 }); //



    this.dataChart2_2 = {
      labels: supname,
      datasets: [

        {
          label: "เป้าแปลงโครงการ",
          data: sumCntPlan,
          yAxisID: "id1",
          stack: 'Stack 0',
          backgroundColor: "#ffa500",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "เป้าปุ๋ยเคมี2",
          data: cntPlan01,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#006400",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เป้าซ่อมอ้อย",
          data: cntPlan02,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#9ACD32",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เป้าปุ๋ยเคมี3",
          data: cntPlan03,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#808000",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เป้าฮอร์โมน",
          data: cntPlan04,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#556B2F",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เป้าอินทรีย์",
          data: cntPlan05,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#66CDAA",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เป้าโดโลไมท์",
          data: cntPlan06,
          yAxisID: "id1",
          stack: 'Stack 1',
          backgroundColor: "#8FBC8B",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "แปลงโครงการสำเร็จ",
          data: sumcntSecPlan,
          yAxisID: "id1",
          stack: 'Stack 2',
          backgroundColor: "#0000FF",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "ปุ๋ยเคมี2สำเร็จ",
          data: cntSecPlan01,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#87CEFA",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ซ่อมอ้อยสำเร็จ",
          data: cntSecPlan02,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#00BFFF",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ปุ๋ยเคมี3สำเร็จ",
          data: cntSecPlan03,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#1E90FF",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ฮอร์โมนสำเร็จ",
          data: cntSecPlan04,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#6495ED",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "อินทรีย์สำเร็จ",
          data: cntSecPlan05,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#7B68EE",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "โดโลไมท์สำเร็จ",
          data: cntSecPlan06,
          yAxisID: "id1",
          stack: 'Stack 3',
          backgroundColor: "#4169E1",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% โครงการที่สำเร็จ',
          data: pcSumTargPlan10,
          fill: false,
          borderColor: '#E60B00',
          tension: 0.05,
          yAxisID: "id2",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
      ],
    };

    this.optionsChart2_2 = {
      responsive: true,
      interaction: {
        intersect: false,
      },
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟเทียบจำนวนโครงการราย' + this.hText,
        fontSize: 18
      },
      scales: {
        stacked: true,
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{

          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /* min: Math.min(0),
             max: Math.max(25),*/
          },
          id: "id1" // incorrect property name.
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /*min: Math.min(0),
            max: Math.max(110),*/
          },

          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,

          },
          //display: false,
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: {
            display: false
          },
          //yAxisID: "id2"
          id: "id2" // incorrect property name.
        }

        ],

      }
    };
  }
  dataChart3: any;
  optionsChart3: any;
  TopicChart03() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_areas - b.pc_areas});
    let supzone = data.map(function (elem) { return elem.supname });
    let sum_areas = data.map(function (elem) { return parseFloat(elem.sum_areas.toFixed()) }); // ปลายฝน
    let areas_er = data.map(function (elem) { return parseFloat(elem.areas_er.toFixed()) }); // ปลายฝน
    let areasY_st = data.map(function (elem) { return parseFloat(elem.areasY_st.toFixed()) }); // ตอ
    let areas_sr = data.map(function (elem) { return parseFloat(elem.areas_sr.toFixed()) }); // ต้นฝน
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // รวม
    let landvalue_left = data.map(function (elem) { return parseFloat(elem.landvalue_left.toFixed()) }); //

    let pc_areas = data.map(function (elem) { return elem.pc_areas }); // pc
    this.dataChart3 = {

      labels: supzone,
      datasets: [

        {
          type: 'line',
          label: "พื้นที่อ้อยเป้าหมาย",
          data: sum_areas,
          fill: true,
          borderColor: '#008100',
          tension: 0.1,
          yAxisID: "id1",
          order: 1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          datalabels: {
            color: '#008100',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
          , stack: 'Stack 0',
        },
        {
          label: "อ้อยปลายฝน",
          data: areas_er,
          yAxisID: "id1",
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            //acchor:'center',
            align: 'center',
            offset: 10
          }
          , stack: 'Stack 1',
        },
        {
          label: "อ้อยตอ",
          data: areasY_st,
          yAxisID: "id1",
          backgroundColor: "#1abc9c",
          datalabels: {
            color: 'black',
            //acchor:'center',
            align: 'center',
            offset: 10
          }
          , stack: 'Stack 1',
        },
        {
          label: "อ้อยต้นฝน",
          data: areas_sr,
          yAxisID: "id1",
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            //acchor:'center',
            align: 'center',
            offset: 10
          }
          , stack: 'Stack 1',
        },
        /*
        {
          label:"พื้นที่อ้อยทั้งหมด" ,
          data: landvalue,
          yAxisID: "id1",
          backgroundColor: "#9834DB",
          datalabels:{
            color:'black',
            acchor:'end',
            align:'top',
            offset:10
          }
          ,stack: 'Stack 2',
        },
        {
          label:"หักพื้นที่เสียหาย" ,
          data: landvalue_left,
          yAxisID: "id1",
          backgroundColor: "#FFCC8F",
          datalabels:{
            color:'black',
            acchor:'end',
            align:'top',
            offset:10
          }
          ,stack: 'Stack 3',
        },*/
        {
          type: 'line',
          label: '% พื้นที่รวม',
          yAxisID: "id2",
          data: pc_areas,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#E60B00',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
      ],
    };
    this.optionsChart3 = {
      responsive: true,
      interaction: {
        intersect: false,
      },
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          //anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString()
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟพื้นที่ปลูกแต่ละ' + this.hText + ' แยกประเภทอ้อย',
        fontSize: 18
      },
      scales: {
        stacked: true,
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{

          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            //min: Math.min(0),
            //max: Math.max(25),
          },
          id: "id1" // incorrect property name.
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /* min: Math.min(0),
             max: Math.max(120),*/
          },

          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,

          },
          //display: false,
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: {
            display: false
          },
          //yAxisID: "id2"
          id: "id2" // incorrect property name.
        }

        ],

      }
    };
  }

  dataChartP: any;
  optionsChartP: any;
  TopicChart14() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_hardSoilBlast - b.pc_hardSoilBlast});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let pc_hardSoilBlast = data.map(function (elem) { return elem.pc_hardSoilBlast }); // 
    let pc_Groove15 = data.map(function (elem) { return elem.pc_Groove15 }); // 
    let pc_FertilizerRound1a = data.map(function (elem) { return elem.pc_FertilizerRound1a }); // 
    let pc_FertilizerRound2a = data.map(function (elem) { return elem.pc_FertilizerRound2a }); // 
    let pc_GerminationPercent90 = data.map(function (elem) { return elem.pc_GerminationPercent90 }); // 
    let pc_NaturalFerti_a = data.map(function (elem) { return elem.pcNaturalFerti_a }); // 
    let pc_AmountDolomite_a = data.map(function (elem) { return elem.pc_AmountDolomite_a }); // 


    this.dataChartP = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: '% ระเบิดดินดาน',
          data: pc_hardSoilBlast,
          fill: false,
          borderColor: '#7ac5cd',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          /*datalabels:{
            color:'#ffffff',   
            offset:10,
            backgroundColor: '#404040',
          }*/
        },
        {
          type: 'line',
          label: '% ระยะร่อง >=150',
          data: pc_Groove15,
          fill: false,
          borderColor: '#53868b',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
        ,
        {
          type: 'line',
          label: '% ใส่เคมี งวด 1',
          data: pc_FertilizerRound1a,
          fill: false,
          borderColor: '#006b3c',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
        ,
        {
          type: 'line',
          label: '% ใส่เคมี งวด 2',
          data: pc_FertilizerRound2a,
          fill: false,
          borderColor: '#ed872d',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
        ,
        {
          type: 'line',
          label: '% การงอก >=90',
          data: pc_GerminationPercent90,
          fill: false,
          borderColor: '#e30022',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
        ,
        {
          type: 'line',
          label: '% ใส่อินทรีย์',
          data: pc_NaturalFerti_a,
          fill: false,
          borderColor: '#fff600',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
        ,
        {
          type: 'line',
          label: '% ใส่โดโลไมต์',
          data: pc_AmountDolomite_a,
          fill: false,
          borderColor: '#a3c1ad',
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        }
      ],
    };
    this.optionsChartP = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟแสดงผลงาน กิจกรรม ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            max: 120
          },
        },],
      }
    };
  }

  dataChartUp: any;
  optionsChartUp: any;
  TopicChart16() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_hardSoilBlast - b.pc_hardSoilBlast});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let cntY = data.map(function (elem) { return elem.cntY }); // 
    let cntUpdate = data.map(function (elem) { return elem.cntUpdate }); // 
    let pc_cntUpdate = data.map(function (elem) { return elem.pc_cntUpdate }); // 

    this.dataChartUp = {
      labels: supzone,
      datasets: [
        {
          type: 'line',
          label: '% แปลงอัพเดต',
          yAxisID: "id2",
          data: pc_cntUpdate,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#ffb3ba',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          label: "จำนวนแปลงทั้งหมด",
          data: cntY,
          backgroundColor: '#baffc9',
          yAxisID: "id1",
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
          datalabels: {
            color: 'green',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "แปลงที่อัพเดต",
          data: cntUpdate,
          yAxisID: "id1",
          backgroundColor: "#ffdfba",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'center',
            offset: 10
          }
        },

      ],
    };
    this.optionsChartUp = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          fontSize: 12,
          //anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString()
            //return value/1000+'k'
          }
        }
      },

      //maintainAspectRatio: true,
      title: {
        display: true,
        text: 'แปลงที่มีการอัพเดตกิจกรรม-รายเดือน ' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          //stacked: true,
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          id: "id1" // incorrect property name.
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            /*min: Math.min(0),*/
            max: Math.max(110),
          },
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          //display: false,
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: {
            display: false
          },
          //yAxisID: "id2"
          id: "id2" // incorrect property name.
        }],
      }
    };
  }


  dataChart4: any;
  optionsChart4: any;
  TopicChart04() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_hardSoilBlast - b.pc_hardSoilBlast});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let hardSoilBlast = data.map(function (elem) { return parseFloat(elem.hardSoilBlast.toFixed()) }); // ระยะ
    let tg_landvalue_New_Y = data.map(function (elem) { return parseFloat(elem.tg_landvalue_New_Y.toFixed()) }); // เป้า
    let pc_hardSoilBlast = data.map(function (elem) { return elem.pc_hardSoilBlast }); // เป้า
    //console.log('hardSoilBlast',hardSoilBlast)

    this.dataChart4 = {
      labels: supzone,
      datasets: [
        {
          label: "เป้าหมาย",
          data: tg_landvalue_New_Y,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ระเบิดดินดาน",
          data: hardSoilBlast,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ระเบิดดินดาน',
          yAxisID: "id2",
          data: pc_hardSoilBlast,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#E99c02',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart4 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟแสดงผลงานระเบิดดาน เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2"
        }
        ],
      }
    };
  }

  canetype: any;
  load_seed() {
    let year = this.year_S;
    //this.spinner.show();
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_seed_group_w?year=' + year.yearCr)
      .then(res => {
        this.canetype = res.data.recordset;
        this.canetype.sort(function (a, b) { return b.pc_per_areaY - a.pc_per_areaY });
        //this.spinner.hide();
      }).catch(err => {
        this.spinner.hide();
        throw (err)
      })
  }

  dataChart6: any;
  optionsChart6: any;
  TopicChart06() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_Groove15 - b.pc_Groove15});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let Groove15 = data.map(function (elem) { return parseFloat(elem.Groove15.toFixed()) }); // ระยะ
    let Groove16 = data.map(function (elem) { return parseFloat(elem.Groove16.toFixed()) }); // ระยะ
    let pc_Groove15 = data.map(function (elem) { return elem.pc_Groove15 }); // ระยะ
    let pc_Groove16 = data.map(function (elem) { return elem.pc_Groove16 }); // ระยะ

    let landvalue_SR_Y = data.map(function (elem) { return elem.landvalue_SR_Y }); // เป้า
    this.dataChart6 = {

      labels: supzone,
      datasets: [
        {
          label: "เป้าหมาย",
          data: landvalue_SR_Y,
          yAxisID: "id1",
          backgroundColor: "#3498db",
          datalabels: {
            color: '#3498db',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ระยะร่อง มากกว่า 1.5ม.",
          data: Groove15,
          yAxisID: "id1",
          backgroundColor: "#f39c02",
          datalabels: {
            color: '#f39c02',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ระยะร่อง มากกว่า 1.6ม.",
          data: Groove16,
          yAxisID: "id1",
          backgroundColor: "#1abc78",
          datalabels: {
            color: '#1abc78',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ระยะร่อง 1.5ม.',
          yAxisID: "id2",
          data: pc_Groove15,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#E99c02',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '% ระยะร่อง 1.6ม.',
          yAxisID: "id2",
          data: pc_Groove16,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#28B950',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
      ],
    };
    this.optionsChart6 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ระยะร่อง เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          id: "id1"
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }

        ],
      }
    };
  }

  dataChart7: any;
  optionsChart7: any;
  TopicChart07() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_FertilizerRound1a - b.pc_FertilizerRound1a});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let FertilizerRound1 = data.map(function (elem) { return parseFloat(elem.FertilizerRound1.toFixed()) }); // ระยะ
    let FertilizerRound1a = data.map(function (elem) { return parseFloat(elem.FertilizerRound1a.toFixed()) }); // ระยะ
    let pc_FertilizerRound1 = data.map(function (elem) { return elem.pc_FertilizerRound1 }); // ระยะ
    let pc_FertilizerRound1a = data.map(function (elem) { return elem.pc_FertilizerRound1a }); // ระยะ
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้า
    this.dataChart7 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: landvalue,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่ใส่ปุ๋ยรอบ1",
          data: FertilizerRound1a,
          backgroundColor: "#3618db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "ใส่ปุ๋ยเคมี 1 ภายใน 7 วัน",
          data: FertilizerRound1,
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 1',
          yAxisID: "id2",
          data: pc_FertilizerRound1a,
          fill: false,
          borderColor: '#3518db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 1 ภายใน 7 วัน',
          yAxisID: "id2",
          data: pc_FertilizerRound1,
          fill: false,
          borderColor: '#f36c12',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart7 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่ปุ๋ยเคมี 1 เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            max: Math.max(120),
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  dataChart8: any;
  optionsChart8: any;
  TopicChart08() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_FertilizerRound2a - b.pc_FertilizerRound2a});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let FertilizerRound2 = data.map(function (elem) { return parseFloat(elem.FertilizerRound2.toFixed()) }); // ระยะ
    let FertilizerRound2a = data.map(function (elem) { return parseFloat(elem.FertilizerRound2a.toFixed()) }); // ระยะ
    let pc_FertilizerRound2 = data.map(function (elem) { return elem.pc_FertilizerRound2 }); // ระยะ
    let pc_FertilizerRound2a = data.map(function (elem) { return elem.pc_FertilizerRound2a }); // ระยะ
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้า
    this.dataChart8 = {

      labels: supzone,
      datasets: [
        {
          label: "เป้าหมาย",
          data: landvalue,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่ใส่ปุ๋ยรอบ2",
          data: FertilizerRound2a,
          backgroundColor: "#3618db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "ใส่ปุ๋ย 2 ภายใน 45 วัน",
          data: FertilizerRound2,
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 2',
          yAxisID: "id2",
          data: pc_FertilizerRound2a,
          fill: false,
          borderColor: '#3518db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 2 ภายใน 45 วัน',
          yAxisID: "id2",
          data: pc_FertilizerRound2,
          fill: false,
          borderColor: '#f36c12',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart8 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่ปุ๋ยเคมี 2 เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            beginAtZero: true,
            max: Math.max(120),
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',

          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }
  dataChart9: any;
  optionsChart9: any;
  TopicChart09() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_FertilizerRound3a - b.pc_FertilizerRound3a});
    let supzone = data.map(function (elem) { return elem.supname }); //
    let FertilizerRound3 = data.map(function (elem) { return parseFloat(elem.FertilizerRound3.toFixed()) }); // ระยะ
    let FertilizerRound3a = data.map(function (elem) { return parseFloat(elem.FertilizerRound3a.toFixed()) }); // ระยะ
    let pc_FertilizerRound3 = data.map(function (elem) { return elem.pc_FertilizerRound3 }); // ระยะ
    let pc_FertilizerRound3a = data.map(function (elem) { return elem.pc_FertilizerRound3a }); // ระยะ
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้า
    this.dataChart9 = {

      labels: supzone,
      datasets: [
        {
          label: "เป้าหมาย",
          data: landvalue,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่ใส่ปุ๋ยรอบ3",
          data: FertilizerRound3a,
          backgroundColor: "#3618db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ใส่ปุ๋ย 3 ภายใน 90 วัน",
          data: FertilizerRound3,
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 3',
          yAxisID: "id2",
          data: pc_FertilizerRound3a,
          fill: false,
          borderColor: '#3518db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
        {
          type: 'line',
          label: '% ใส่ปุ๋ยเคมี 3 ภายใน 90 วัน',
          yAxisID: "id2",
          data: pc_FertilizerRound3,
          fill: false,
          borderColor: '#f36c12',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };
    this.optionsChart9 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่ปุ๋ยเคมี 3 เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            beginAtZero: true,
            max: Math.max(120),
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',

          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }


  dataChart10: any;
  optionsChart10: any;
  dataChart101: any;
  optionsChart101: any;
  TopicChart10() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    ////data = data.sort(function(a, b){return a.pcNaturalFerti_a - b.pcNaturalFerti_a});
    let supzone = data.map(function (elem) { return elem.supname });
    let tg_landvalue_New_Y = data.map(function (elem) { return parseFloat(elem.tg_landvalue_New_Y.toFixed()) }); // เป้าหมาย
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้าหมาย
    let NaturalFerti_n = data.map(function (elem) { return parseFloat(elem.NaturalFerti_n.toFixed()) }); // ใส่อินทรีย์
    let NaturalFerti_a = data.map(function (elem) { return parseFloat(elem.NaturalFerti_a.toFixed()) }); // ใส่อินทรีย์
    let pcNaturalFerti_n = data.map(function (elem) { return elem.pcNaturalFerti_n }); // ใส่อินทรีย์
    let pcNaturalFerti_a = data.map(function (elem) { return elem.pcNaturalFerti_a }); // ใส่อินทรีย์
    this.dataChart10 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: tg_landvalue_New_Y,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ใส่อินทรีย์",
          data: NaturalFerti_n,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ใส่อินทรีย์',
          yAxisID: "id2",
          data: pcNaturalFerti_n,
          fill: false,
          borderColor: '#3588db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
      ],
    };

    this.optionsChart10 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่อินทรีย์อ้อยปลูกใหม่ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          }, id: "id1"
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }

        ],
      }
    };
    this.dataChart101 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: landvalue,
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ใส่อินทรีย์",
          data: NaturalFerti_a,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ใส่อินทรีย์',
          yAxisID: "id2",
          data: pcNaturalFerti_a,
          fill: false,
          borderColor: '#3588db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
      ],
    };

    this.optionsChart101 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่อินทรีย์อ้อยทั้งหมด เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          }, id: "id1"
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  dataChart11: any;
  optionsChart11: any;
  dataChart111: any;
  optionsChart111: any;
  TopicChart11() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_AmountDolomite_a - b.pc_AmountDolomite_a});
    let supzone = data.map(function (elem) { return elem.supname });
    let tg_landvalue_New_Y = data.map(function (elem) { return parseFloat(elem.tg_landvalue_New_Y.toFixed()) }); // เป้าหมาย
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้าหมาย
    let AmountDolomite_n = data.map(function (elem) { return parseFloat(elem.AmountDolomite_n.toFixed()) }); // ใส่อินทรีย์
    let AmountDolomite_a = data.map(function (elem) { return parseFloat(elem.AmountDolomite_a.toFixed()) }); // ใส่อินทรีย์
    let pc_AmountDolomite_n = data.map(function (elem) { return elem.pc_AmountDolomite_n }); // ใส่อินทรีย์
    let pc_AmountDolomite_a = data.map(function (elem) { return elem.pc_AmountDolomite_a }); // ใส่อินทรีย์
    this.dataChart11 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: tg_landvalue_New_Y,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ใส่โดโลไมท์",
          data: AmountDolomite_n,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },//pc_AmountDolomite_n
        {
          type: 'line',
          label: '% ใส่โดโลไมท์',
          yAxisID: "id2",
          data: pc_AmountDolomite_n,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#3588db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };

    this.optionsChart11 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่โดโลไมท์ ของอ้อยปลูกใหม่ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
    this.dataChart111 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: landvalue,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ใส่โดโลไมท์",
          data: AmountDolomite_a,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },//pc_AmountDolomite_n
        {
          type: 'line',
          label: '% ใส่โดโลไมท์',
          yAxisID: "id2",
          data: pc_AmountDolomite_a,
          //backgroundColor: "#E4F1FA",
          fill: false,
          borderColor: '#3588db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,
        },
      ],
    };

    this.optionsChart111 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ใส่โดโลไมท์ ของอ้อยทั้งหมด เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  dataChart12: any;
  optionsChart12: any;
  TopicChart12() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_GerminationPercent90 - b.pc_GerminationPercent90});
    let supzone = data.map(function (elem) { return elem.supname });
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้าหมาย
    let pc_GerminationPercent90 = data.map(function (elem) { return elem.pc_GerminationPercent90 }); //
    let pc_GerminationPercent95 = data.map(function (elem) { return elem.pc_GerminationPercent95 }); //
    let GerminationPercent90 = data.map(function (elem) { return parseFloat(elem.GerminationPercent90.toFixed()) }); //
    let GerminationPercent95 = data.map(function (elem) { return parseFloat(elem.GerminationPercent95.toFixed()) }); //
    this.dataChart12 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: landvalue,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "% การงอก>=90",
          data: GerminationPercent90,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

        {
          label: "% การงอก>=95",
          data: GerminationPercent95,
          backgroundColor: "#3648db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% เป้าหมายการงอก>=90',
          yAxisID: "id2",
          data: pc_GerminationPercent90,
          fill: false,
          borderColor: '#30a8db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
        {
          type: 'line',
          label: '% เป้าหมายการงอก>=95',
          yAxisID: "id2",
          data: pc_GerminationPercent95,
          fill: false,
          borderColor: '#3058db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },
      ],
    };

    this.optionsChart12 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน % การงอก เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }
  dataChart13: any;
  optionsChart13: any;
  TopicChart13() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    //data = data.sort(function(a, b){return a.pc_lastweet - b.pc_lastweet});
    let supzone = data.map(function (elem) { return elem.supname });
    let landvalue = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed()) }); // เป้าหมาย
    let lastweet = data.map(function (elem) { return parseFloat(elem.lastweet.toFixed()) }); // ใส่อินทรีย์
    let pc_lastweet = data.map(function (elem) { return elem.pc_lastweet }); // ใส่อินทรีย์
    this.dataChart13 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: landvalue,
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ไม่มีวัชพืช",
          data: lastweet,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          type: 'line',
          label: '% ไม่มีวัชพืช',
          yAxisID: "id2",
          data: pc_lastweet,
          //backgroundColor: "#3588db",
          fill: false,
          borderColor: '#3588db',
          tension: 0.05,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 10,

        },

      ],
    };

    this.optionsChart13 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน ไม่มีวัชพืช เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  dataChart16: any;
  optionsChart16: any;
  TopicChart25() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    let supzone = data.map(function (elem) { return elem.supname });
    let GA = data.map(function (elem) { return elem.score_A }); // A
    let GB = data.map(function (elem) { return elem.score_B }); // B
    let GC = data.map(function (elem) { return elem.score_C }); // C
    this.dataChart16 = {

      labels: supzone,
      datasets: [

        {
          label: "เกรด A",
          data: GA,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#f39c12",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เกรด B",
          data: GB,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "เกรด C",
          data: GC,
          backgroundColor: "#1abc9c",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
      ],
    };

    this.optionsChart16 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'เกรดชาวไร่ A B C ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        }],
      }
    };
  }

  dataChart17: any;
  optionsChart17: any;
  dataChart18: any;
  optionsChart18: any;
  dataChart19: any;
  optionsChart19: any;
  dataChart20: any;
  optionsChart20: any;
  dataChart21: any;
  optionsChart21: any;
  dataChart22: any;
  optionsChart22: any;
  TopicChart17() {
    this.typeChart = 'bar';
    let data = this.listDataNow;
    let supzone = data.map(function (elem) { return elem.supname });
    let tg_landvalue_New_Y = data.map(function (elem) { return parseFloat(elem.tg_landvalue_New_Y.toFixed()) }); // A เป้า 17
    let tg_landvalue_new = data.map(function (elem) { return parseFloat(elem.tg_landvalue_new.toFixed()) }); // B เป้า 18 เป้า 19
    let landvalue_new = data.map(function (elem) { return parseFloat(elem.landvalue_new.toFixed()) }); // ค่า 17
    let landvalue_P = data.map(function (elem) { return parseFloat(elem.landvalue_P.toFixed()) }); // ค่า 18
    let landvalue_Pa = data.map(function (elem) { return parseFloat(elem.landvalue_Pa.toFixed()) }); // ค่า  19

    let sum_money_amt = data.map(function (elem) { return parseFloat(((elem.sum_money_amt) / 1000).toFixed()) }); //
    let sum_money_amtNew = data.map(function (elem) { return parseFloat(((elem.sum_money_amtNew) / 1000).toFixed()) }); //
    let sum_money_amtST = data.map(function (elem) { return parseFloat(((elem.sum_money_amtST) / 1000).toFixed()) }); //
    let sum_area_amt = data.map(function (elem) { return parseFloat(elem.sum_area_amt.toFixed()) }); //
    let sum_area_amtNew = data.map(function (elem) { return parseFloat(elem.sum_area_amtNew.toFixed()) }); //
    let sum_area_amtST = data.map(function (elem) { return parseFloat(elem.sum_area_amtST.toFixed()) }); //

    this.dataChart20 = {

      labels: supzone,
      datasets: [

        {
          label: "จ่ายเงินส่งเสริมทั้งหมด * 1,000 บาท",
          data: sum_money_amt,
          backgroundColor: "#f39c12",
          datalabels: {
            color: '#f39c12',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่จ่ายเงินส่งเสริม",
          data: sum_area_amt,
          backgroundColor: "#3498db",
          yAxisID: "id2",
          datalabels: {
            color: '#3498db',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
      ],
    };

    this.optionsChart20 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน จ่ายเงินส่งเสริมทั้งหมด เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            callback: function (value) {
              var ranges = [
                { divider: 1e3, suffix: 'M' },
                { divider: 1e0, suffix: 'k' }
              ];
              function formatNumber(n) {
                for (var i = 0; i < ranges.length; i++) {
                  if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                  }
                }
                return n;
              }
              return /*'$' +*/ formatNumber(value);
            }
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
    this.dataChart21 = {

      labels: supzone,
      datasets: [

        {
          label: "จ่ายเงินส่งเสริมอ้อยใหม่ * 1,000 บาท",
          data: sum_money_amtNew,
          backgroundColor: "#f39c12",
          datalabels: {
            color: '#f39c12',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่จ่ายเงินส่งเสริมอ้อยใหม่",
          data: sum_area_amtNew,
          backgroundColor: "#3498db",
          yAxisID: "id2",
          datalabels: {
            color: '#3498db',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
      ],
    };

    this.optionsChart21 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน จ่ายเงินส่งเสริมอ้อยใหม่ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            callback: function (value) {
              var ranges = [
                { divider: 1e3, suffix: 'M' },
                { divider: 1e0, suffix: 'k' }
              ];
              function formatNumber(n) {
                for (var i = 0; i < ranges.length; i++) {
                  if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                  }
                }
                return n;
              }
              return /*'$' +*/ formatNumber(value);
            }
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
    this.dataChart22 = {

      labels: supzone,
      datasets: [

        {
          label: "จ่ายเงินส่งเสริมอ้อยตอ * 1,000 บาท",
          data: sum_money_amtST,
          backgroundColor: "#f39c12",
          datalabels: {
            color: '#f39c12',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "พื้นที่จ่ายเงินส่งเสริมอ้อยตอ",
          data: sum_area_amtST,
          backgroundColor: "#3498db",
          yAxisID: "id2",
          datalabels: {
            color: '#3498db',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
      ],
    };

    this.optionsChart22 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน จ่ายเงินส่งเสริมอ้อยตอ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            callback: function (value) {
              var ranges = [
                { divider: 1e3, suffix: 'M' },
                { divider: 1e0, suffix: 'k' }
              ];
              function formatNumber(n) {
                for (var i = 0; i < ranges.length; i++) {
                  if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                  }
                }
                return n;
              }
              return /*'$' +*/ formatNumber(value);
            }
          },
        },
        {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            //  labelString: 'Commissions',
            beginAtZero: true,
          },
          display: true,
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };


    this.dataChart17 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: tg_landvalue_New_Y,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#9b59b6",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "จ่ายเงินส่งเสริมของอ้อยปลูกใหม่",
          data: landvalue_new,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

      ],
    };

    this.optionsChart17 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน การจ่ายเงินส่งเสริมของอ้อยปลูกใหม่ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        }],
      }
    };


    this.dataChart18 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: tg_landvalue_new,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#9b59b6",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "แปลงขอวงเงิน แต่ยังไม่ปลูก",
          data: landvalue_P,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

      ],
    };

    this.optionsChart18 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน แปลงขอวงเงิน 6 พัน แต่ยังไม่ปลูก เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        }],
      }
    };

    this.dataChart19 = {

      labels: supzone,
      datasets: [

        {
          label: "เป้าหมาย",
          data: tg_landvalue_new,
          // backgroundColor: ['#1abc9c', '#3498db', '#9b59b6',  '#bdc3c7', '#f39c13','#000000']
          backgroundColor: "#9b59b6",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "แปลงขอวงเงิน 6 พัน และทำกิจกรรมครบ",
          data: landvalue_Pa,
          backgroundColor: "#3498db",
          datalabels: {
            color: 'black',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },

      ],
    };

    this.optionsChart19 = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString().replaceAll(',', ',')
          }
        }
      },

      maintainAspectRatio: false,
      title: {
        display: true,
        text: 'กราฟผลงาน แปลงขอวงเงิน 6 พัน และทำกิจกรรมครบ เทียบเป้าหมาย ราย' + this.hText,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          ticks: {
            fontSize: 14
          }
        }],
        yAxes: [{
          ticks: {
            fontSize: 14,
            beginAtZero: true,
          },
        }],
      }
    };
  }




  ngOnDestroy(): void {
    this.allkpidata = null;
    this.supportterlist = null;
    this.areacode = null;
    this.arealist = null;
    this.partcode = null;
    this.partlist = null;
    this.listDataNow = null;
    this.listDataNow2 = null;


  }
}
